<template>
  <v-row align="start">

    <!-- Upload Box -->
    <v-col cols="12" md="3">
      <h3 class="text-h6 font-weight-bold mb-2">বর্তমান ছবি <span class="text-error">*</span></h3>
      <v-divider />
      <div class="image-upload-box mt-2" @click="$refs.photoInput.click()">
        <img v-if="previewImage" :src="previewImage" class="preview-image" alt="Preview">
        <div v-else class="upload-placeholder">
          <v-icon size="50" color="grey">mdi-image-outline</v-icon>
          <div class="mt-2 text-grey">ছবি নির্বাচন করুন</div>
        </div>

        <v-btn icon size="40" color="white" class="edit-btn" elevation="3">
          <v-icon color="primary">mdi-pencil</v-icon>
        </v-btn>
        <input ref="photoInput" type="file" accept="image/*" hidden @change="handleImage">
      </div>
    </v-col>

    <v-col cols="12" md="9">
      <h3 class="text-h6 font-weight-bold mb-2">ছবি বাছাইয়ের ক্ষেত্রে লক্ষণীয়</h3>
      <v-divider />
      <ul class="instruction-list mt-2">
        <li>অনধিক ৬ মাস আগে তোলা পাসপোর্ট সাইজের ছবি আপলোড করুন</li>
        <li>ছবির ব্যাকগ্রাউন্ড অবশ্যই সাদা হতে হবে</li>
        <li>ছবিতে মাথা ও মুখমন্ডলের কোনো অংশ কাটা পড়া অবস্থায় দাখিল করা থেকে বিরত থাকুন</li>
        <li>মুখের অবস্থান সোজা হতে হবে</li>
        <li>মোবাইল বা গ্রাফিক্সে এডিট করা ছবি দাখিল করা থেকে বিরত থাকুন</li>
        <li>ছবি আপলোডের সময় ছবি বক্সের ভিতরে পুরোভাবে রিসাইজ করে দাখিল করুন</li>
      </ul>
    </v-col>

  </v-row>
</template>

<script>
export default {
  name: "PhotoComponent",
  data() {
    return {
      previewImage: null,
      imageFile: null,
    }
  },
  methods: {
    handleImage(event) {
      const file = event.target.files[0]
      if (!file) return
      this.imageFile = file
      this.previewImage = URL.createObjectURL(file)
    },
  },
};
</script>

<style scoped>
.form-label {
  display: block;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 700;
  color: rgb(var(--v-theme-secondary));
}

/* Upload Box */
.image-upload-box {
  position: relative;
  width: 220px;
  height: 220px;
  border: 2px solid rgb(var(--v-theme-border));
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  background: rgb(var(--v-theme-surface));
  transition: all 0.3s ease;
}

.image-upload-box:hover {
  border-color: rgb(var(--v-theme-primary));
}

/* Placeholder */
.upload-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Preview */
.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Edit Button */
.edit-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}

/* Instructions */
.instruction-list {
  padding-left: 20px;
  line-height: 2;
  color: rgb(var(--v-theme-secondary));
}

.instruction-list li {
  margin-bottom: 6px;
}

/* Mobile */
@media (max-width: 768px) {
  .image-upload-box {
    width: 100%;
    max-width: 250px;
    margin: auto;
  }
}
</style>

